import { render, staticRenderFns } from "./ManagementTeamCard.vue?vue&type=template&id=6370ede3&scoped=true"
import script from "./ManagementTeamCard.vue?vue&type=script&lang=js"
export * from "./ManagementTeamCard.vue?vue&type=script&lang=js"
import style0 from "./ManagementTeamCard.vue?vue&type=style&index=0&id=6370ede3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6370ede3",
  null
  
)

export default component.exports